import { OrderStateEnums, OrderTypeEnums } from "src/app/enum/order-enums";
import { CostCenterModel } from "../archive/cost-center.model";

export class OrderModel {
  orderId: number = 0;
  branchId: number = 0;
  consecutive: number = 0;
  purchaseOrderNumber: string | null = null;
  dateOrder: Date = new Date;
  orderStateId: number = OrderStateEnums.open;
  orderTypeId: number = OrderTypeEnums.rental;
  costCenterId: number = 0;
  costCenter: CostCenterModel = new CostCenterModel();
  advertiser: string = "";
  sellerId: number = 0;
  conceptId: number | null = null;
  quotationId: number | null = null;
  observationAnnul: string | null = null;
  observation: string | null = null;
  observationRemission: string | null = null;
  observationCommercial: string | null = null;
  createDate: string = "";
  userNameCreate: string = "";
  updateDate: string | null = null;
  userNameUpdate: string | null = null;

  //variable para controlar si están limpiando el formulario:
  clearForm: boolean = true;
}